import WebhookErrorListStore from 'stores/webook/WebhookErrorListStore';

export interface IWebhook {
    id?: string;
    name?: string;
    description?: string;
    body?: string;
    url?: string;
    option?: string;
    headers?: string;
    method?: 'GET' | 'POST';
    version?: number;
    includeObservable?: boolean;
    isCertSelfSigned?: boolean;
}

export default class WebhookStore {
    webhook: IWebhook = {};
    errors: WebhookErrorListStore;

    constructor(webhook: IWebhook) {
        this.update(webhook);
        this.errors = new WebhookErrorListStore(webhook?.id);
    }

    update(webhook: IWebhook): void {
        this.webhook = {
            ...this.webhook,
            ...webhook
        };
    }
}
